import React from 'react'
import './NewArrivals.css'

function NewArrivals() {
    const listOfnewArrival = ['https://firebasestorage.googleapis.com/v0/b/blinkkopticals-6c609.appspot.com/o/IMG-20230324-WA0000.jpg?alt=media&token=bc3575b6-43d4-4b8e-a349-53d5d9ff164f', 'https://firebasestorage.googleapis.com/v0/b/blinkkopticals-6c609.appspot.com/o/IMG-20230324-WA0001.jpg?alt=media&token=9c524566-b6be-4240-919d-6d8d42c97000', 'https://firebasestorage.googleapis.com/v0/b/blinkkopticals-6c609.appspot.com/o/IMG-20230326-WA0000.jpg?alt=media&token=6bc6185c-9cdb-4548-907e-3323d6c4c1ba', 'https://firebasestorage.googleapis.com/v0/b/blinkkopticals-6c609.appspot.com/o/330890401_1112530086811852_4327136387439709416_n.webp.jpg?alt=media&token=8c70483f-977c-480d-b00d-343f1dec1af6']
    console.log(listOfnewArrival);
    return (
        <div className='newarrivals'>
            <div className='new_arrivals_heading'>
                <p className='new_arrival_text'>New Arrivals</p>
            </div>
            <div className='new_arrival_list'>
                {listOfnewArrival.map((item, index) => {
                    return (<img className='new_arrival_img' src={item} alt={item} key={index} />)
                }
                )}
            </div>
        </div>
    )
}

export default NewArrivals